import api, { armorAPI } from '~/services/api';
import { stringifyUrlSearchParams } from '~/utils/url';

const baseURL = CONFIG.apiBaseUrl;
const transactionLimit = '1000';

const getTransactions = (
  carrier: unknown,
  startDate: string,
  endDate: string,
  limit = transactionLimit,
) => {
  const params = {
    expand: ['rate', 'parcel'],
    filter: {
      carrier,
      shipment_end_date: endDate,
      shipment_start_date: startDate,
      status: 'success',
    },
    page: {
      limit,
      number: '1',
    },
  };
  return api.request({
    baseURL,
    method: 'GET',
    params,
    paramsSerializer: (params) => stringifyUrlSearchParams(params, { arrayFormat: 'brackets' }),
    url: 'transactions/pickups/search',
  });
};

const getCarrierAccounts = (carrier: string) =>
  api.request({
    baseURL,
    method: 'GET',
    params: {
      carrier,
    },
    url: 'carrier_accounts',
  });

const getCarrierBuildingLocationTypes = (carrierId: string) =>
  api.request({
    baseURL,
    method: 'GET',
    params: {},
    url: `transactions/pickups/building_location_types/${carrierId}`,
  });

const sendPickupsRequest = (payload) =>
  armorAPI.request({
    data: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: 'pickups/',
  });

export { getCarrierAccounts, getCarrierBuildingLocationTypes, getTransactions, sendPickupsRequest };
